// Shared listing-score formatting helpers.

// Convert a 0-100 percentage score to the 0-10 points scale (1 decimal).
export const convertToPoints = (percentage) => {
    if (percentage === null || percentage === undefined) return 0;
    return (percentage / 10).toFixed(1);
};

// Indicator colour for a 0-100 percentage score.
export const getScoreColor = (score) => {
    if (score >= 80) return '#4CAF50';
    if (score >= 60) return '#EF9629';
    return '#F44336';
};

// Shape a raw history/score record into the format the score-detail views expect.
export const transformScoreData = (asin, scoreData) => {
    const analysis = scoreData.analysis || {};
    const productInfo = scoreData.product_info || {};
    return {
        asin: asin,
        title: productInfo.title || 'Product Title',
        main_image: productInfo.main_image || '',
        b_plus_images: productInfo.b_plus_images || productInfo.all_images || [],
        description: productInfo.description || '',
        bullet_points: productInfo.bullet_points || [],
        specifications: productInfo.specifications || [],
        a_plus_content: productInfo.a_plus_content || false,
        analysis: {
            total_score: scoreData.total_score || 0,
            percentage_score: scoreData.score || 0,
            overall_analysis: analysis.overall_analysis || '',
            component_scores: analysis.component_scores || {},
            competitive_advantages: analysis.competitive_advantages || [],
            improvement_areas: analysis.improvement_areas || [],
            critical_gaps: analysis.critical_gaps || [],
            recommendations: analysis.recommendations || [],
        },
        product_info: productInfo,
    };
};
